function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SvgScatterIcon(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _jsx("svg", _objectSpread(_objectSpread({
      width: 48,
      height: 48,
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {}, {
      children: /*#__PURE__*/_jsxs("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#C1C0C0",
          d: "M44 43v1H4v-1z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#939293",
          d: "M44 34v1H4v-1zM44 25v1H4v-1zM44 16v1H4v-1z"
        }), /*#__PURE__*/_jsx("circle", {
          fill: "#7DA4FF",
          cx: 9.5,
          cy: 37.5,
          r: 1.5
        }), /*#__PURE__*/_jsx("circle", {
          fill: "#7DA4FF",
          cx: 16.5,
          cy: 30.5,
          r: 1.5
        }), /*#__PURE__*/_jsx("circle", {
          fill: "#7DA4FF",
          cx: 22.5,
          cy: 36.5,
          r: 1.5
        }), /*#__PURE__*/_jsx("circle", {
          fill: "#7DA4FF",
          cx: 28.5,
          cy: 30.5,
          r: 1.5
        }), /*#__PURE__*/_jsx("circle", {
          fill: "#7DA4FF",
          cx: 15.5,
          cy: 38.5,
          r: 1.5
        }), /*#__PURE__*/_jsx("circle", {
          fill: "#7DA4FF",
          cx: 23.5,
          cy: 25.5,
          r: 1.5
        }), /*#__PURE__*/_jsx("circle", {
          fill: "#7DA4FF",
          cx: 19.5,
          cy: 19.5,
          r: 1.5
        }), /*#__PURE__*/_jsx("circle", {
          fill: "#7DA4FF",
          cx: 29.5,
          cy: 19.5,
          r: 1.5
        }), /*#__PURE__*/_jsx("circle", {
          fill: "#7DA4FF",
          cx: 32.5,
          cy: 26.5,
          r: 1.5
        }), /*#__PURE__*/_jsx("circle", {
          fill: "#7DA4FF",
          cx: 36.5,
          cy: 13.5,
          r: 1.5
        })]
      })
    }))
  );
}
export default SvgScatterIcon;
//# sourceMappingURL=ScatterIcon.js.map